import Vue from 'vue'
// Vue Tooltip
import '@/assets/css/tooltip.scss'
import VTooltip from 'v-tooltip'

Vue.use(VTooltip)
